// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let RivalIQ;
if (typeof window === 'undefined') {

    RivalIQ = {
        utils: {}
    };

} else {
    RivalIQ = window.RivalIQ;
    RivalIQ.module('utils', function () {});
}

(function () {

    'use strict';

    const channelFinderFlags = {};

    channelFinderFlags.flags = {
        SKIP_NONE: 0,
        SKIP_TWITTER: 1,
        SKIP_FACEBOOK: 2,
        // 4 is defunct
        // 8 is defunct
        SKIP_YOUTUBE: 16,
        SKIP_INSTAGRAM: 32,
        // 64 is defunct
        SKIP_TIKTOK: 128,
        SKIP_ALL: 179 // NOTE must be the sum of all flags above
    };

    channelFinderFlags.convertBitfieldToObject = function (bitfield) {

        const retObj = {};
        retObj.twitter = (bitfield & channelFinderFlags.flags.SKIP_TWITTER) > 0;
        retObj.facebook = (bitfield & channelFinderFlags.flags.SKIP_FACEBOOK) > 0;
        retObj.youtube = (bitfield & channelFinderFlags.flags.SKIP_YOUTUBE) > 0;
        retObj.instagram = (bitfield & channelFinderFlags.flags.SKIP_INSTAGRAM) > 0;
        retObj.tiktok = (bitfield & channelFinderFlags.flags.SKIP_TIKTOK) > 0;

        return retObj;
    };

    channelFinderFlags.convertObjectToBitfield = function (o) {

        let retVal = 0;
        if (o.twitter) {
            retVal += channelFinderFlags.flags.SKIP_TWITTER;
        }
        if (o.facebook) {
            retVal += channelFinderFlags.flags.SKIP_FACEBOOK;
        }
        if (o.youtube) {
            retVal += channelFinderFlags.flags.SKIP_YOUTUBE;
        }
        if (o.instagram) {
            retVal += channelFinderFlags.flags.SKIP_INSTAGRAM;
        }
        if (o.tiktok) {
            retVal += channelFinderFlags.flags.SKIP_TIKTOK;
        }

        return retVal;
    };

    // NOTE export the results, for both server and client
    if (typeof window === 'undefined') {
        module.exports = channelFinderFlags;
    } else {
        RivalIQ.utils.channelFinderFlags = channelFinderFlags;
    }

})();
